
import React, { useState } from 'react';
import {
  Box, Button, Divider, Grid, Paper, Typography
} from '@mui/material';
import { AvatarCustom, HeadlinePage, JobStatus, Workflow, WorkflowForm } from 'components/common';
import { ROUTES } from 'consts';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useStyle } from '../styles';
import { useTheme } from '@mui/material/styles';
import { withPermission } from 'hoc';
const wfexample = require('../../../consts/workflow-example-ejecucion.json');

const JobRunWorkflowDumb = ({ data, handleStop, validPermission }) => {
  const showActions = validPermission(data.proyect_id, 'isExecute');

  const classes = useStyle();
  const [t] = useTranslation();
  const [switchTab, setSwitchTab] = useState(false);
  const theme = useTheme();

  const details = [
    { primary: 'jobRunWorkflow.components.label.project', secondary: data.proj_name },
    { primary: 'jobRunWorkflow.components.label.environment', secondary: data.ansible_runer_path }
  ];

  const dates = [
    { label: 'jobRunWorkflow.components.label.created', date: data.created },
    { label: 'jobRunWorkflow.components.label.start', date: data.start },
    { label: 'jobRunWorkflow.components.label.finish', date: data.finish }
  ];

  function handleSwitchTab() {
    window.scrollTo(0, 0);
    setSwitchTab(!switchTab);
  }

  const DateLabel = ({label, date}) => {
    const dateFormatted = date ? moment(date).subtract(3, 'hours').format('lll') : "-"; 

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <Typography variant="body1">
          {t(label)}
        </Typography>
        <Typography variant="h6">
          {dateFormatted}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <HeadlinePage
        title={!switchTab ? 'jobRunWorkflow.headline' : 'jobRunWorkflow.editHeadLine'}
        goBack={!switchTab ? ROUTES.JOB_LIST : handleSwitchTab}
      />

      <Paper className={classes.paperStyle} sx={{ display: switchTab ? 'none!important' : 'flex' }}>
        <Box sx={{ width: '100%', display: 'flex', gap: 2, flexDirection: 'row' }}>
          <Typography variant="h6" sx={{ padding: '8px 0px' }}>
            {t('jobRunWorkflow.components.title', { job: data.name })}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'center' }}>
            <JobStatus status={data.status} size={'large'}/>
          </Box>
        </Box>

        <Grid container spacing={2}>
          {details.map((d, index) => (
            <Grid item key={index} xs={12} sm={12} md={6} lg={6}>
              <AvatarCustom
                primary={d.primary}
                secondary={d.secondary}
                sx={{ p: 0 }}
              />
            </Grid>
          ))}

          <Grid item xs={12} sm={12} md={12} lg={12}> <Divider sx={{mb: 2}} /></Grid>

          {dates.map((d, index) => (
            <Grid item key={index} xs={12} sm={6} md={4} lg={4}>
              <DateLabel label={d.label} date={d.date}/>
            </Grid>
          ))}

          <Grid item xs={6} sm={6} md={6} lg={6}>
              <Typography variant="h6" sx={{ padding: '8px 0px' }}>
                {t('jobRunWorkflow.components.subtitle')}
              </Typography>
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button variant="outlined" onClick={handleSwitchTab}>
              {t('jobRunWorkflow.components.button.view')}
            </Button>
            {showActions &&
              <Button variant="outlined" onClick={handleStop} type="button">
                {t('jobRunWorkflow.components.button.stopAll')}
              </Button>
            }
          </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box sx={{
              width: '100%',
              height: '300px',
              overflow:'hidden',
              border: `1px solid ${theme.palette.grey[400]}`,
              borderRadius: 1
            }}>
              { (data.ls_dependencies && data.ls_dependencies.length > 0) ?
                (
                  <Workflow
                    wfParam={data.ls_dependencies}
                    updateWF={(x)=>{console.info(x)}}
                    mode="ej"
                    scrollScale={true}
                  />
                )
                :(
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                    <Typography variant="h5">{t('workflowEdit.components.task.notResults')}</Typography>
                  </Box>
                )
              }
            </Box>
          </Grid>
        </Grid>

      </Paper>



      <Box sx={{ display: !switchTab ? 'none' : 'inherit' }}>
        { (data.ls_dependencies && data.ls_dependencies.length > 0) &&
            <Box sx={{ width: '100%', overflow: 'auto', position: 'absolute', top: '64px', zIndex: 0 }}>
            <Workflow
              wfParam={data.ls_dependencies}
              updateWF={(x)=>{console.info(x)}}
              mode="ej"
              scale={1.3}
              scrollScale={true}
            />
          </Box>
        }
      </Box>
    </>
  );
};

export default withPermission(JobRunWorkflowDumb, "jobs");
